import {view} from '@sail/ui/deprecated';
import {defineMessage, useIntl} from 'react-intl';

const msg = defineMessage({
  id: 'support_conversations_client.support_conversations.screens.test_screen.screen_name',
  description: 'Name of test screen',
  defaultMessage: 'Test Screen',
  translate: false,
});

export function TestScreen() {
  const intl = useIntl();
  return (
    <view.div data-testid="test-screen">{intl.formatMessage(msg)}</view.div>
  );
}
